<style>
    .mo-work .mo-work--hint {
        position: absolute;
        bottom: 2px;
        right: 2px;
        background: #017eff;
        color: #fff;
        padding: 1px 5px;
        border-radius: 10px;
        font-size: 10px;
    }
    .user-mo-work .mo-work--author-info > div {
        display: flex;
        align-items: center;
    }
    .user-mo-work .mo-work--author-medal {
        width: 14px;
        height: 14px;
        margin: auto 0 auto 8px;
    }
</style>

<template>
    <div class="user-mo-work">
        <div @click="preview(work)">
            <div class="mo-work--wrapper">
                <div class="mo-work--collect" @click.prevent.stop="collect(work.id)">
                    <iconSymbol name="work-collect1" :class="{ 'mo-work--icon__red': hasCollected }" />
                </div>

                <img ref="wrap" class="mo-work--img" :src="thumbUrl" :alt="work.title" />
                <!-- <div
                    class="mo-work--description"
                    :class="{ 'mo-work--des-ellipsis': descriptionEll }"
                    ref="des"
                >
                    <div class="mo-work--desinfo">{{ work.description }}</div>
                </div> -->
            </div>
        </div>

        <span class="mo-work--text">{{ work.title }}</span>

        <div class="mo-work--number-area" v-show="workType != 'PENDING'">
            <div>
                <iconSymbol name="pv" class="mo-work--icon" />
                <span>{{ getNumberText(work.pv) }}</span>
            </div>
            <div>
                <iconSymbol name="work-used" class="mo-work--icon" />
                <span>{{ getNumberText(work.used) }}</span>
            </div>
            <div>
                <iconSymbol
                    name="zan"
                    class="mo-work--icon mo-work--icon__pointer"
                    :class="{ 'mo-work--icon__red': hasLiked }"
                    @click.native="like(work.id)"
                />
                <span>{{ getNumberText(work.like) }}</span>
            </div>
            <!-- <div>
                <iconSymbol
                    name="collect"
                    class="mo-work--icon mo-work--icon__collect mo-work--icon__pointer"
                    :class="{ 'mo-work--icon__red': hasCollected }"
                    @click.native="collect(work.id)"
                />
                <span>{{ getNumberText(work.collect) }}</span>
            </div> -->
        </div>
        <div class="mo-work--author-area">
            <div class="mo-work--author-info" @click="toUser(work.user_id)">
                <div>
                    <iconSymbol v-if="!avatar" class="mo-work--avatar" name="default-avatar" />
                    <img v-if="avatar" :src="avatar" class="mo-work--avatar" alt />
                    <span class="mo-work--author-name" :style="{ color: work.fuser ? '#f98e5a' : null }">{{ safeName }}</span>
                    <img src="https://images.edrawmax.cn/1.png" class="mo-work--author-medal" v-if="isMedal" alt="" />
                </div>
            </div>
            <span class="mo-work--use-condition">{{ priceHint }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Work",
        components: {},
        props: {
            work: {
                type: Object,
                required: true,
            },
            workType: {
                type: String,
            },
        },
        data() {
            return {
                descriptionEll: false,
            };
        },
        computed: {
            medalIds() {
                return this.$store.state.medalIds;
            },
            isMedal() {
                return this.medalIds.includes(this.work.user_id);
            },
            thumbUrl() {
                if (this.work.thumbSrc) {
                    //只有通过updateWaterfall更新的作品才有thumbSrc
                    return this.work.thumbSrc;
                } else {
                    return window["GLOBAL"].PUBLIC_OSS_HOST + this.work.url + "thumb.png";
                }
            },
            //是否点赞过
            hasLiked() {
                let likeIds = this.$store.state.userPage.likeIds;
                return likeIds.includes(this.work.id);
            },
            //是否点赞过
            hasCollected() {
                let collectIds = this.$store.state.userPage.collectIds;
                return collectIds.includes(this.work.id);
            },
            //头像
            avatar() {
                let ava = "",
                    work = this.work;
                if (work.avatar) ava = "data:image/png;base64," + work.avatar;
                else if (work.avatar_url) ava = work.avatar_url;
                else if (work.user && work.user.avatar) ava = "data:image/png;base64," + work.avatar;
                else if (work.user && work.user.avatar_url) ava = work.user.avatar_url;
                return ava;
            },
            //如果是author电话的话，将电话号码后6位隐藏
            //如果是邮箱的话，隐藏邮箱后缀
            safeName() {
                let name = this.work.author || this.work.user.nick_name;
                if (name.match(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)) {
                    name = name.substr(0, name.indexOf("@"));
                }
                if (name.match(/^1[3456789]\d{9}$/)) {
                    name = name
                        .split("")
                        .map((v, idx) => {
                            if (idx > 4) {
                                return "*";
                            } else {
                                return v;
                            }
                        })
                        .join("");
                }
                return name;
            },
            priceHint() {
                let work = this.work;
                let hint = "";
                if (work.allow_copy) {
                    if (work.price > 0) {
                        hint = "￥" + work.price;
                    } else if (work.member_free) {
                        hint = "会员免费";
                    } else {
                        hint = "免费";
                    }
                } else {
                    hint = "仅公开";
                }
                return hint;
            },
            clickUserWordIds() {
                return this.$store.state.userPage.clickUserWordIds;
            },
        },
        mounted() {},
        methods: {
            // checkdes(e){
            //     let wrapHeight = event.target.offsetHeight;
            //     let desDom = this.$refs.des;
            //     if(desDom.offsetHeight + 10 > wrapHeight){
            //         desDom.style.height = (wrapHeight - 10) + "px";
            //         this.descriptionEll = true;
            //     }
            // },
            linkURL(work) {
                if (this.workType == "PENDING" || work.review_status == "pending") {
                    return "https://www.edrawmax.cn/online/app.html?" + this.$zipFileName(`obj=${work.obj}`);
                } else {
                    return `https://www.edrawmax.cn/templates/file/${work.id}`;
                }
            },
            getNumberText(num) {
                if (Number(num) > 1000) {
                    return (Number(num) / 1000).toFixed(1) + "k";
                } else {
                    return num;
                }
            },
            getAvatar(work) {
                let ava = "";
                if (work.avatar) ava = "data:image/png;base64," + work.avatar;
                else if (work.avatar_url) ava = work.avatar_url;
                return ava;
            },
            like(id) {
                this.$bus.$emit("actionToWork", { type: "like", id, from: this.workType });
            },
            collect(id) {
                this.$bus.$emit("actionToWork", { type: "collect", id, from: this.workType });
            },
            toUser(id) {
                this.$store.commit("toVisitUser", {
                    id,
                });
                this.$bus.$emit("reloadUser");
                let len = this.clickUserWordIds.length;
                if ((len >= 1 && this.clickUserWordIds[len - 1] != id) || len == 0) {
                    this.$store.commit("userPage/clickUserWordId", id);
                }
            },
            preview(work) {
                this.$store.commit("toActiveWork", work);
                this.$store.commit("toTplCenter", {
                    name: "previewContext",
                    data: "userWorks",
                });
            },
        },
    };
</script>
